import React from 'react';
import { Progress } from 'reactstrap';
import Loader from '../../../common/loader';
import TooltipItem from './Tooltip';
const ProgressBar = ({
  headerName = '',
  tooltipContent = '',
  tooltipPlace = '',
  tooltipOpen = '',
  ProgressBarData = [],
  progressBarLoader = true,
  ProgressBarTables = '',
}) => {
  let progressBarItem;
  const { questionModel, questionStatsModel } = ProgressBarTables;
  return (
    <div className='card'>
      <div className='card-header'>
        {headerName}
        <div className='card-actions card_action_tooltip float-right'>
          <TooltipItem
            key='1'
            tooltipId='1'
            content={tooltipContent}
            place_tip={tooltipPlace}
            tooltipOpen={tooltipOpen}
          />
        </div>
      </div>
      <div className=''>
        <table className='table table-hover mb-0 compress_table'>
          {progressBarLoader ? (
            <div className='card-block-loader'>
              <Loader />
            </div>
          ) : (
            <tbody>
              {ProgressBarData.map((item, index) => {
                progressBarItem = Math.round(
                  (item[`${questionModel}.${questionStatsModel}.attemptCount`] /
                  item[`${questionModel}.questionsCount`]) *
                  100,
                  );
                if (progressBarItem < 1) {
                  progressBarItem = 1;
                }
                return (
                  <tr key={index}>
                    <td>
                      <div className='question_row'>
                        <div className='question_count'>Q.{index + 1}</div>
                        <div className='question_bar'>
                          <p>{item.chapterName}</p>
                          <div className='bar_wrap'>
                            <div>
                              <Progress
                                className='progress-xs'
                                color='info'
                                value={progressBarItem}
                                style={{ width: `${progressBarItem}%` }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/ProgressBar.jsx